var styles = {
  "Popover": "Online-Store-UI-Popover_11w91",
  "fadein": "Online-Store-UI-Popover--fadein_1y35x",
  "hidden": "Online-Store-UI-Popover--hidden_1xupn"
};

export { styles as default };
